import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=7af245b6&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"
import style0 from "./Game.vue?vue&type=style&index=0&id=7af245b6&lang=scss&scoped=true&"
import style1 from "./Game.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af245b6",
  null
  
)

component.options.__file = "Game.vue"
export default component.exports